module.exports = __webpack_public_path__ + "img/step-3.954eb238.png";